module.exports = __webpack_public_path__ + "static/media/Akoya_dark.36cec734.png";